/**
 * Generic pill/tab segment toggle control.
 *
 * Usage:
 *   <SegmentToggle
 *     options={[
 *       { value: 'sessions', label: 'Sessions' },
 *       { value: 'measurements', label: 'Measurements' },
 *     ]}
 *     value={mode}
 *     onChange={setMode}
 *   />
 *
 * NOTE: the .chart-segment-toggle / .segment-btn styles this component relies on were
 * removed with OrgReports.scss and are not defined anywhere else. Add them to a co-located
 * stylesheet before using this component in a rendered view.
 */

type Option<T extends string> = { value: T; label: string };

type Props<T extends string> = {
  options: Option<T>[];
  value: T;
  onChange: (v: T) => void;
};

function SegmentToggle<T extends string>({ options, value, onChange }: Props<T>) {
  return (
    <div className='chart-segment-toggle'>
      {options.map((opt) => (
        <button
          key={opt.value}
          className={`segment-btn${value === opt.value ? ' segment-btn--active' : ''}`}
          onClick={() => onChange(opt.value)}
          type='button'
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}

export default SegmentToggle;
